import type { CrewlinkClient } from '../supabase-client';
import type { AppUserRow } from '../database.types';

/**
 * Writer wrapper for `ensure_app_user` (migration 0001).
 *
 * The layering rule (ARCHITECTURE §2, INV-T02): UI → query hooks → writer
 * wrappers → Postgres RPC. This is the wrapper layer. UI code never calls
 * `.rpc(...)` directly and never calls `.insert(...)` at all.
 *
 * Creates the profile row on first sign-in with the device timezone. If the
 * profile already exists the database IGNORES the supplied value and returns
 * the stored row unchanged — "seeded once" is a server-side guarantee, not a
 * client convention (D-009).
 *
 * The identity is taken from `auth.uid()` inside the function; it is never
 * passed from here (INV-T23).
 */
export async function ensureAppUser(
  client: CrewlinkClient,
  deviceTimeZone: string,
): Promise<AppUserRow> {
  const { data, error } = await client.rpc('ensure_app_user', {
    p_timezone: deviceTimeZone,
  });

  if (error) throw error;
  if (!data) throw new Error('ensure_app_user returned no profile row');

  return data;
}
